import { render, staticRenderFns } from "./LimitModal.vue?vue&type=template&id=0228e2cf&"
import script from "./LimitModal.vue?vue&type=script&lang=js&"
export * from "./LimitModal.vue?vue&type=script&lang=js&"
import style0 from "@/styles/LimitModal.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports